// extracted by mini-css-extract-plugin
export default {"main-wrapper":"style_main-wrapper__syHSN","offcanvas":"style_offcanvas__hy6Ej"};